import { Field, ID, InputType } from 'type-graphql'
import { ActionArgs } from '../../action/ActionArgs'
import type { IAction } from '../../action/IAction'
import { ShippingRate } from '../../shipping/ShippingRate'
import type { Logistic } from '../Logistic'

@InputType()
export class SetLogisticShippingRateArgs extends ActionArgs {
  @Field(() => ID)
  logisticId: string

  @Field(() => ShippingRate)
  rate: ShippingRate
}

export interface ISetLogisticShippingRate extends IAction<Logistic, SetLogisticShippingRateArgs> {}
